import html2canvas from 'html2canvas';
import React, { ReactNode } from 'react';
import '../components/d3Charts/charts/Graphs.css';
import Modal from '../components/Modal/Modal';
//import { CopyGraphToClipBoard } from '../utils/CopyGraphToClipBoard';
//import MessageFooter from '../components/message/MessageFooter';
interface GraphWrapperProps {
    children: ReactNode;
}

const GraphWrapper: React.FC<GraphWrapperProps> = ({ children }) => {
    const parentDiv = React.useRef<any>();
    const [isModalOpen, setIsModalOpen] = React.useState<boolean>(false);
    const [imageSrc, setImageSrc] = React.useState<string | null>(null);
    // const copyToClipBoard = () => {
    //     CopyGraphToClipBoard(parentDiv.current);
    // }
    // Function to capture the content of parentDiv as an image
    const handleShareClick = (e: any) => {
        // Stop the modal from opening when clicking on the select element or other child elements
        if (e.target.closest('.chartOptionDiv')) {
            return;
        }

        if (parentDiv.current) {
            html2canvas(parentDiv.current).then((canvas) => {
                const img = canvas.toDataURL();
                setImageSrc(img);
                setIsModalOpen(true); // Show the modal
            });
        }
    };

    return (
        <div className="messageDiv">
            <div ref={parentDiv} style={{minHeight:'350px', fontSize: "12px", position: 'relative', display: 'flex', alignItems: "center", borderWidth: 1, borderColor: "#dedede", borderRadius: 8, borderStyle: 'solid', padding:'20px 0px' }} onClick={handleShareClick}>
                {children}
            </div>
            {/* <MessageFooter copyToClipBoard={copyToClipBoard} handleShareClick={handleShareClick} type={"graphs"} /> */}
            {imageSrc && (
                <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
                    <button onClick={() => setIsModalOpen(false)} style={modalStyles.closeButton}>X</button>
                    <img src={imageSrc} alt="Captured Graph" style={modalStyles.image} />
                </Modal>
            )}
        </div>
    )
}
const modalStyles: { closeButton: React.CSSProperties; image: React.CSSProperties } = {
    closeButton: {
        position: 'absolute',
        top: '20px',
        right: '30px',
        background: '#9bb4b1',
        color: 'white',
        border: 'none',
        padding: '5px 10px',
        cursor: 'pointer',
        borderRadius: '100px',
        width: '35px',
        height: '35px',
    },
    image: {
        maxWidth: '100%',
        maxHeight: '100%',
        display: 'block',
        margin: '0 auto',
    },
};

export default GraphWrapper;